/*doc
---
title: cursorLoading()
name: cursorLoading
category: Javascript - General
---

This sets/unsets an element's cursor to be `progress`. The default
behavior is to set the cursor to `progress`, but the plugin accepts a boolean
to determine if it should be set or not.

For the most part, this should be used on the page's `<body>` to indicate to the
user that the page is loading.

```html_example
<a href="#" class="cursor-example btn btn-lg btn-primary">This has a loading cursor.</a>
```

```js_example
$(document).on('turbolinks:load', function() {
  $('.cursor-example').cursorLoading()
})
```
*/

(function ($) {
  'use strict'

  $.fn.cursorLoading = cursorLoading

  function cursorLoading(isLoading) {
    isLoading = (isLoading === undefined) || isLoading

    return this.each(function() {
      this.style.cursor = isLoading ? 'progress' : ''
    })
  }

}(jQuery))
